module.exports = __webpack_public_path__ + "d94db53da827e83f67aea7eef6ba3818.svg";